import { useEffect, useState } from "react";
import { FolderOpen, Folder } from "lucide-react";
import { api } from "@/lib/api";

export const formatFolderDate = (d) =>
  new Date(`${d}T00:00:00`).toLocaleDateString("id-ID", { weekday: "short", day: "numeric", month: "short", year: "numeric" });

export const DateFolders = ({ eventId, value, onChange, reloadKey, testPrefix = "date-folder" }) => {
  const [dates, setDates] = useState([]);
  useEffect(() => { api.get(`/events/${eventId}/dates`).then((r) => setDates(r.data)).catch(() => setDates([])); }, [eventId, reloadKey]);
  useEffect(() => {
    if (value && dates.length && !dates.some((d) => d.date === value)) onChange(null);
  }, [dates]); // eslint-disable-line react-hooks/exhaustive-deps

  if (dates.length === 0) return null;
  const total = dates.reduce((s, d) => s + d.count, 0);
  const Chip = ({ date, label, count, testId }) => {
    const active = value === date;
    const Icon = active ? FolderOpen : Folder;
    return (
      <button onClick={() => onChange(date)} data-testid={testId}
        className={`shrink-0 inline-flex items-center gap-2 rounded-xl border px-3.5 py-2 text-sm transition-colors ${active ? "bg-zinc-900 border-zinc-900 text-white" : "bg-white border-zinc-200 text-zinc-700 hover:border-zinc-400"}`}>
        <Icon className={`h-4 w-4 ${active ? "text-blue-300" : "text-blue-600"}`} />
        <span className="font-semibold">{label}</span>
        <span className={`font-mono-x text-xs ${active ? "text-zinc-300" : "text-zinc-500"}`}>{count.toLocaleString("id-ID")} foto</span>
      </button>
    );
  };
  return (
    <div className="mb-6 -mx-1 px-1 flex gap-2 overflow-x-auto pb-1" data-testid={`${testPrefix}-list`}>
      <Chip date={null} label="Semua tanggal" count={total} testId={`${testPrefix}-all`} />
      {dates.map((d) => <Chip key={d.date} date={d.date} label={formatFolderDate(d.date)} count={d.count} testId={`${testPrefix}-${d.date}`} />)}
    </div>
  );
};
